<template>
    <div class="table_wrap">
        <el-table class="list-table" header-cell-class-name="list-header" :data="topicData"
                  style="width: 100%;" height="695" empty-text="데이터가 없습니다.">
            <el-table-column
                class="table_no"
                type="index"
                label="No"
                min-width="70"
                class-name="num text-center"
                :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="등급" width="100" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                      {{ returnLevel(scope.row.ot_level)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="분야" width="" class-name="text-center" prop="oc_kor">
            </el-table-column>
            <el-table-column label="노출" width="" class-name="text-center">
              <template slot-scope="scope">
                  <span>
                    {{ scope.row.ot_display===0? '미노출' : '노출' }}
                  </span>
              </template>
            </el-table-column>
            <el-table-column label="주제(한국어)" width="" class-name="text-center" prop="ot_kor"></el-table-column>
            <el-table-column label="주제(영어)" width="" class-name="text-center" prop="ot_eng"></el-table-column>
            <el-table-column label="주제(중국어)" width="" class-name="text-center" prop="ot_cn"></el-table-column>
            <el-table-column label="등록일" width=" 200" class-name="text-center">
              <template slot-scope="scope">
                    <span>
                        {{returnDateFormat(scope.row.created_at, 'YYYY-MM-DD HH:mm')}}
                    </span>
              </template>
            </el-table-column>
            <el-table-column label="옵션" min-width="50" class-name="text-center">
                <template slot-scope="scope">
                    <div class="row-info">
                        <el-button @click="goDetail(scope.row.ot_idx)">
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import util from "@/mixins/util";
    import EventBus from "@/utils/event-bus";
    import dateMixins from "@/mixins/dateMixins";

    export default {
        name: "TopicListDefaultLayout",
        mixins: [dateMixins],
        inject: ['topicListSetData'],
        components: {},
        provide() {
            return {}
        },
        props: {
            topicData: {default: () => []},
            paginationData: {
                default: () => { return { total: 0, page: 0, size: 0, }}
            },
        },
        data() {
            return {
            //    languages : appLanguage
            }
        },
        created() {},
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods: {
            tableIdx(index) {
                return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
            },
          returnLevel(level){
              switch(level){
                case 0 :
                  return '입문'
                case 1 :
                  return '초급'
                case 2 :
                  return '중·고급'
                // case 3 :
                //   return '고급'
              }
          },
            returnStatusName(status) {
                switch (status){
                    case 10:
                        return ''
                    case 20:
                        return '완료'
                    case 30:
                        return '불가'
                    default:
                        return ''
                }
            },
            goDetail(idx) {
                this.$router.push(`/content/topic/${idx}`);
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>